// components/LeftSidebar.js
import React, { useState } from "react";
import {
    MdAdd,
    MdLayers,
    MdMap,
    MdPrint,
    MdDraw,
    MdCompare,
} from "react-icons/md";
import {
    FaChevronCircleLeft, FaChevronCircleRight, FaChartBar,FaFilter
} from "react-icons/fa";
import { FaTools } from 'react-icons/fa';
import { GoReport } from "react-icons/go";
import ReportModeler from "../Report/ReportModeler";
import "./LeftSidebar.css";

function LeftSidebar({ isCollapsed, onAddClick, onToggle, accessProfile, activePanel, setOverlay }) {
    const [isReportModal, setIsReportModal] = useState(false);
    const canRead = accessProfile?.canRead?.value;
    const canWrite = accessProfile?.canWrite?.value;
    const canReadOJ = accessProfile?.canReadOrgJedinicu?.value;
    const canWriteOJ = accessProfile?.canWriteOrgJedinicu?.value;
    const canUseGeneral = canRead || canWrite || canReadOJ || canWriteOJ;
    const canUseDraw = canWrite || canWriteOJ;
    const canUseReport = canRead || canWrite || canReadOJ || canWriteOJ;

    return (
        <div className={`left-sidebar ${isCollapsed ? "collapsed" : ""}`}>
            <ul className="menu">
                <li
                    className={`menu-item ${activePanel === "Dodavanje" ? "active" : ""} ${!canUseGeneral ? "disabled" : ""}`}
                    onClick={canUseGeneral ? () => onAddClick("Dodavanje") : undefined}
                    title="Dodavanje"
                >
                    <MdAdd className="icon" />
                    <span className="text">Dodavanje</span>
                </li>
                <li
                    className={`menu-item ${activePanel === "Slojevi" ? "active" : ""} ${!canUseGeneral ? "disabled" : ""}`}
                    onClick={canUseGeneral ? () => onAddClick("Slojevi") : undefined}
                    title="Slojevi"
                >
                    <MdLayers className="icon" />
                    <span className="text">Slojevi</span>
                </li>
                <li
                    className={`menu-item ${activePanel === "Filter" ? "active" : ""} ${!canUseGeneral ? "disabled" : ""}`}
                    onClick={canUseGeneral ? () => onAddClick("Filter") : undefined}
                    title="Filter"
                >
                    <FaFilter className="icon" />
                    <span className="text">Filter</span>
                </li>
                <li
                    className={`menu-item ${activePanel === "Bazni stilovi" ? "active" : ""} ${!canUseGeneral ? "disabled" : ""}`}
                    onClick={canUseGeneral ? () => onAddClick("Bazni stilovi") : undefined}
                    title="Bazni stilovi"
                >
                    <MdMap className="icon" />
                    <span className="text">Bazni stilovi</span>
                </li>
                <li
                    className={`menu-item ${activePanel === "Alati za mjerenje" ? "active" : ""} ${!canUseGeneral ? "disabled" : ""}`}
                    onClick={canUseGeneral ? () => onAddClick("Alati za mjerenje") : undefined}
                    title="Alati za mjerenje"
                >
                    <FaTools className="icon" />
                    <span className="text">Alati za mjerenje</span>
                </li>
                <li
                    className={`menu-item ${activePanel === "Štampanje" ? "active" : ""} ${!canUseGeneral ? "disabled" : ""}`}
                    onClick={canUseGeneral ? () => onAddClick("Štampanje") : undefined}
                    title="Štampanje"
                >
                    <MdPrint className="icon" />
                    <span className="text">Štampanje</span>
                </li>
                <li
                    className={`menu-item ${activePanel === "Dijagram" ? "active" : ""} ${!canUseGeneral ? "disabled" : ""}`}
                    onClick={canUseGeneral ? () => onAddClick("Dijagram") : undefined}
                    title="Dijagram"
                >
                    <FaChartBar className="icon" />
                    <span className="text">Dijagram</span>
                </li>
                <li
                    className={`menu-item ${activePanel === "Crtanje" ? "active" : ""} ${!canUseDraw ? "disabled" : ""}`}
                    onClick={canUseDraw ? () => onAddClick("Crtanje") : undefined}
                    title="Alati za crtanje"
                >
                    <MdDraw className="icon" />
                    <span className="text">Alati za crtanje</span>
                </li>
                {  /*   <li
                    className={`menu-item ${activePanel === "Topološke analize" ? "active" : ""} ${!canUseGeneral ? "disabled" : ""}`}
                    onClick={canUseGeneral ? () => onAddClick("Topološke analize") : undefined}
                    title="Topološke analize"
                >
                    <MdOutlineTerrain className="icon" />
                    <span className="text">Topološke analize</span>
                </li>
               */} <li
                    className={`menu-item ${activePanel === "Poređenje slojeva" ? "active" : ""} ${!canUseGeneral ? "disabled" : ""}`}
                    onClick={canUseGeneral ? () => onAddClick("Poređenje slojeva") : undefined}
                    title="Poređenje slojeva"
                >
                    <MdCompare className="icon" />
                    <span className="text">Poređenje slojeva</span>
                </li>
                <li
                    className={`menu-item ${activePanel === "Izvještaj" ? "active" : ""} ${!canUseReport ? "disabled" : ""}`}
                    onClick={canUseReport ? () => setIsReportModal(true) : undefined}
                    title="Izvještaj"
                >
                    <GoReport className="icon" />
                    <span className="text">Izvještaj</span>
                </li>

            </ul>
            {/* Dugme za collapse se ne prikazuje na mobilnim uređajima */}
            <div
                className={`collapse-toggle ${activePanel ? "disabled" : ""}`}
                onClick={!activePanel ? onToggle : undefined}
                title={activePanel ? "Zatvorite aktivni panel da biste upravljali sidebar-om" : isCollapsed ? "Prikaži" : "Sakrij"}
                style={{ cursor: activePanel ? "not-allowed" : "pointer", opacity: activePanel ? 0.5 : 1 }}
            >

                {isCollapsed ?
                    (<FaChevronCircleRight title="Prikaži" className="icon" />)
                    : (
                        <FaChevronCircleLeft title="Sakrij" className="icon" />
                    )}
                <span className="text">{isCollapsed ? "Prikaži" : "Sakrij"}</span>
            </div>
            <ReportModeler isModalOpen={isReportModal} setIsModalOpen={setIsReportModal} setOverlay={setOverlay} />
        </div >
    );
}

export default LeftSidebar;